import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

/**
 *  This piece of code is related to the way material implemented their shoelace styled components.
 *  Please refer to https://github.com/ngx-formly/ngx-formly/blob/main/src/ui/material/multicheckbox/src/multicheckbox.type.ts
 */
@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[id]': 'id',
  }
})
export class RadioComponent extends FieldType<FieldTypeConfig> {


  getOptions(): any[] {
    return this.props.options as any[];
  }

  onValueChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.formControl.setValue(target.value);
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
    this.formControl.updateValueAndValidity();
  }
}
